declare let process: any;
const env = process.env.NODE_ENV;

export const environment = {
  apiURL:'https://api-dev.glamera.com/api/v5/b2c/rl',
  apiURLC:'https://api-dev.glamera.com/api/v5/b2c/c',
  uploadImageUrl: 'https://api-dev.glamera.com/api/Upload/PostImageFile'
};
